<template>
  <div class="flex">
    <input
      class="form-control"
      :disabled="disabled"
      type="text"
      v-model="displayDate"
    />
    <button type="button" class="btn btn-info" @click="open = !open">
      <i class="icon-fa icon-fa-calendar"></i>
    </button>
    <date-picker
      v-model="date"
      class="small_date"
      :open.sync="open"
      :disabled-date="disabledBeforeTodayAndAfterAWeek"
      @change="updateValue"
      placeholder="Выберите дату"
    >
      <!--                 :shortcuts="shortcuts"-->
    </date-picker>
  </div>
</template>

<script>
// import {Datetime} from 'vue-datetime'
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import "vue2-datepicker/locale/ru";
import moment from "moment";

export default {
  components: {
    // Datetime,
    DatePicker
  },
  props: ["selectedDate", "onSelect", "disabled", "format", 'disabledBefore'],
  data() {
    return {
      max_date: null,
      min_date: null,
      displayDate: null,
      date: new Date(),
      open: false,
      shortcuts: [
        {
          text: "Сегодня",
          onClick() {
            const date = new Date();
            // return a Date
            return date;
          }
        },
        {
          text: "Вчера",
          onClick() {
            const date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24);
            return date;
          }
        }
      ]
    };
  },
  mounted() {
    if (this.selectedDate) {
      this.date = new Date(moment(this.selectedDate).format("YYYY-MM-DD"));
      this.displayDate = moment(this.selectedDate).locale('ru-RU').format(this.format || "DD.MM.YYYY dddd");
    }
  },
  watch: {
    // 'date': {
    //   handler: function (val) {
    //     console.log(val, moment(val, 'DD.MM.YYYY').format('DD.MM.YYYY'));
    //     if (moment(val, 'DD.MM.YYYY').format('DD.MM.YYYY') !== val) return;
    //     if (this.onSelect){
    //       this.onSelect(this.format ? moment(val).format(this.format) : val);
    //     }
    //   }
    // },
    selectedDate: {
      handler: function (val, oldVal) {
        if (this.selectedDate) {
          this.date = new Date(moment(this.selectedDate).format("YYYY-MM-DD"));
          this.displayDate = moment(this.selectedDate).locale('ru-RU').format(this.format || "DD.MM.YYYY dddd");
        }
      },
      deep: true
    }
  },
  methods: {
    updateValue(e) {
      if (this.onSelect) {
        // console.log(
        //   e,
        //   moment(e, "DD.MM.YYYY").format("YYYY-MM-DD") + "T00:00:00,000Z"
        // );
        this.onSelect(
          moment(e, "DD.MM.YYYY").format("YYYY-MM-DD") + "T00:00:00,000Z"
        );
      }
    },
    // dateSelected(e){
    //   console.log(1, e);
    // },
    disabledBeforeTodayAndAfterAWeek(date) {
      let today;
      if (this.disabledBefore) {
        today = new Date(this.disabledBefore);
      } else {
        today = new Date();
      }
      today.setHours(0, 0, 0, 0);

      return date < today;
      // return date < today || date > new Date(today.getTime() + 7 * 24 * 3600 * 1000);
    }
  }
};
</script>

<style>
.small_date {
  /*width: 10px;*/
  width: 0;
}

.small_date input,
.small_date i {
  display: none;
}
</style>

<style scoped>
.btn {
  text-align: center;
}

.btn,
input {
  border-radius: 0;
}
</style>
